import { requireService } from '@repo/di-ez';
import type { GridApi, GridEventListener } from '@repo/go-table';
import { useCallback } from 'react';
import type { MutableRefObject } from 'react';

interface Props {
  apiRef: MutableRefObject<GridApi>;
}

export const useTableEventHandlers = ({ apiRef }: Props) => {
  const notifications = requireService('trajectoryNotifications');

  const onCopy: GridEventListener<'clipboardCopy'> = useCallback(
    (data) => {
      if (!data) {
        return;
      }

      apiRef.current.setRowSelectionModel([]);
      notifications.showSuccessMessageT('common:dataCopied');
    },
    [apiRef, notifications],
  );

  return { onCopy };
};
